import { render, staticRenderFns } from "./document-folders.vue?vue&type=template&id=59d0a958"
import script from "./document-folders.vue?vue&type=script&lang=js"
export * from "./document-folders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports